import React, { useMemo, useState } from "react";

import { Icon } from "components";
import ModalView from "components/OptionsBox/UnitView/ModalView";
import { formatUnitData } from "components/UnitsView/utils";

const ListViewItem = ({ data }) => {
  const formattedData = useMemo(() => formatUnitData(data), [data]);

  return (
    <div className="hayley-flex hayley-w-full hayley-cursor-pointer hayley-items-center hayley-justify-between hayley-space-x-2 hayley-rounded-lg hayley-border hayley-border-solid hayley-border-custom-6 hayley-p-3 hover:hayley-bg-custom-12">
      <div className="hayley-w-full hayley-space-y-2 sm:hayley-w-fit">
        <div className="hayley-flex hayley-w-full hayley-items-center hayley-justify-between hayley-space-x-2 hayley-text-sm hayley-font-semibold hayley-text-secondary">
          <span>{data.unit_name || "- -"}</span>
          <span className="sm:hayley-hidden">{formattedData.unitRentMin}</span>
        </div>
        <div className="hayley-flex hayley-items-center hayley-space-x-2">
          <div className="hayley-flex hayley-items-center hayley-space-x-1">
            <Icon iconType="Bedroom" className="hayley-h-[18px] hayley-w-[18px] hayley-text-custom-4" />
            <span className="hayley-truncate hayley-text-xs hayley-text-secondary">{formattedData?.unitType}</span>
          </div>
          <div className="hayley-flex hayley-items-center hayley-space-x-1">
            <Icon iconType="Size" className="hayley-h-5 hayley-w-5 hayley-text-custom-4" />
            <span className="hayley-truncate hayley-text-xs hayley-text-secondary">{formattedData.areaFt}</span>
          </div>
          <div className="hayley-flex hayley-items-center hayley-space-x-1">
            <Icon iconType="Calendar" className="hayley-h-[14px] hayley-w-[14px] hayley-text-custom-4" />
            <span className="hayley-truncate hayley-text-xs hayley-text-secondary">{formattedData.availabilityDate}</span>
          </div>
          <div className="hayley-invisible hayley-pl-1 group-hover:hayley-visible">
            <Icon iconType="Arrow" className="hayley-h-3 hayley-w-3 hayley-rotate-180 hayley-text-secondary" />
          </div>
        </div>
      </div>
      <div className="hayley-hidden hayley-flex-none hayley-truncate hayley-text-right hayley-text-sm hayley-font-semibold hayley-text-secondary sm:hayley-block">
        {formattedData.unitRentMin ? (data?.is_available ? formattedData.unitRentMin : "") : "$ - -"}
      </div>
    </div>
  );
};

const ExpandableListItem = ({ data, startScheduleTour, expandedItemIndex, onAccordionChange }) => {
  const isExpanded = expandedItemIndex === data.id;

  const handleAccordionClick = () => {
    onAccordionChange(isExpanded ? null : data.id);
  };

  return (
    <div className="hayley-mb-3" onClick={() => handleAccordionClick()}>
      {isExpanded ? (
        <ModalView
          data={data}
          startScheduleTour={startScheduleTour}
          isShowAll={true}
          feesData={data?.fees || []}
          hidePricing={data?.hide_pricing}
          tmlpEnabled={data?.tmlp_enabled}
        />
      ) : (
        <ListViewItem data={data} />
      )}
    </div>
  );
};

const ListView = ({ tableData, startScheduleTour }) => {
  const [expandedItemIndex, setExpandedItemIndex] = useState(tableData[0]?.id);

  const handleAccordionChange = (index) => {
    setExpandedItemIndex(index);
  };

  return (
    <div className="hayley-mb-3">
      {tableData?.map((data, i) => (
        <ExpandableListItem
          key={i}
          data={data}
          startScheduleTour={startScheduleTour}
          expandedItemIndex={expandedItemIndex}
          onAccordionChange={handleAccordionChange}
        />
      ))}
    </div>
  );
};

export default ListView;
